import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Después de aplicar el Protocolo Ambiental del Tomo 1, mi hijo pasó de tener crisis semanales a una en todo el mes. La diferencia fue inmediata. No puedo creer que nadie me había explicado antes la importancia de la humedad del dormitorio.',
  name: 'Valeria G.',
  location: 'Gran Buenos Aires',
  role: 'Mamá de Luciano, 6 años, asmático diagnosticado desde los 2'
}, {
  quote: 'La primera semana cambié los productos de limpieza y puse la funda anti-ácaros en el colchón. La segunda semana ya dormimos toda la noche sin que se despierte tosiendo. Lloré de alivio.',
  name: 'Romina T.',
  location: 'Córdoba',
  role: 'Mamá de Sofía, 4 años, asma moderada'
}, {
  quote: 'El Bono 1 del Protocolo de Crisis 2 AM lo imprimí y lo pegué en la pared del dormitorio. La última vez que tuvo un episodio nocturno supe exactamente qué hacer. No entré en pánico. Y mi hijo se calmó mucho más rápido.',
  name: 'Karina M.',
  location: 'Rosario',
  role: 'Mamá de Tomás, 8 años, lleva 4 años con asma'
}];
export const Testimonials = () => {
  return <section className="py-10 sm:py-14 md:py-16 bg-white" data-id="element-257">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8" data-id="element-259">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          y: -4,
          transition: {
            duration: 0.2
          }
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.1
        }} className="bg-cream-dark p-5 sm:p-6 md:p-8 rounded-2xl shadow-card border border-brand-orange/10 relative cursor-default" data-id="element-260">
              <div className="flex gap-1 mb-3 sm:mb-4" data-id="element-261">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="text-brand-gold fill-brand-gold" data-id="element-262" />)}
              </div>
              <p className="text-gray-700 italic mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base" data-id="element-263">
                "{t.quote}"
              </p>
              <div data-id="element-264">
                <p className="font-bold text-gray-900 text-sm sm:text-base" data-id="element-265">
                  {t.name}{' '}
                  <span className="text-brand-orange font-normal" data-id="element-266">
                    — {t.location}
                  </span>
                </p>
                <p className="text-xs sm:text-sm text-gray-500 mt-1" data-id="element-267">
                  {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};